import { render } from "./TablePaginationNoNums.vue?vue&type=template&id=046ad2ef"
import script from "./TablePaginationNoNums.vue?vue&type=script&lang=js"
export * from "./TablePaginationNoNums.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__